import APIClient from '@/shared/http/clients/api'

const resourceName = 'AprRiscosEspeciais'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAPRTemplateRiscosEspeciaisGrid = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAPRTemplateRiscosEspeciaisGrid?limit=${limit}&index=${index}`, data, config)

const AprRiscosEspeciaisRepository = {
  GetAPRTemplateRiscosEspeciaisGrid
}
export default AprRiscosEspeciaisRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/aprSpecialRisks.js